import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { CURRENCIES, DEFAULT_CURRENCY } from "@/lib/currency";

// Document currency picker (INR ₹ / USD $). Prices are entered in the chosen
// currency as-is — switching it never converts the amounts already typed, so
// pass `hasAmounts` to warn the user to re-check them after a switch.
export function CurrencySelect({ value, onChange, disabled = false, label = "Currency", hint, hasAmounts = false, className = "", testid = "currency-select" }) {
  const change = (v) => {
    if (v !== (value || DEFAULT_CURRENCY) && hasAmounts) {
      toast.warning(`Currency changed to ${v} — amounts are not converted. Re-check every rate and charge.`);
    }
    onChange(v);
  };
  return (
    <div className={className}>
      {label && <Label>{label}</Label>}
      <Select value={value || DEFAULT_CURRENCY} onValueChange={change} disabled={disabled}>
        <SelectTrigger className="mt-1 w-full" data-testid={testid}><SelectValue /></SelectTrigger>
        <SelectContent>
          {CURRENCIES.map((c) => (
            <SelectItem key={c.code} value={c.code} data-testid={`${testid}-${c.code}`}>{c.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      {hint && <div className="text-[11px] text-slate-500 mt-1">{hint}</div>}
    </div>
  );
}

export default CurrencySelect;
